import _ from "lodash";
import qs from "qs";
import Endpoints from "./endpoints.js";

// TODO: modularize this - not all endpoints need to be in here - it would make
// sense to split endpoints from different controllers/areas into different
// files at least

// polyfill fetch for IE11
import "whatwg-fetch";

// const BACKEND_DATE_PARSE_SUBSTR_INDEX = 6;

let endpoints = {};
_.forEach(Endpoints, (url, name) => {
	endpoints[name] = "/api/v1/" + url;
});

const defaultOptions = {
	credentials: "same-origin"
};

// TODO: cleanup default options (DRY)
const defaultPatchOptions = {
	method: "PATCH",
	headers: {
		"Content-Type": "application/json",
		Accept: "*/*"
	}
};

const defaultPutOptions = {
	method: "PUT",
	headers: {
		"Content-Type": "application/json",
		Accept: "*/*"
	}
};

const defaultPostOptions = {
	method: "POST",
	headers: {
		"Content-Type": "application/json",
		Accept: "*/*"
	}
};

const defaultDeleteOptions = {
	method: "DELETE",
	headers: {
		"Content-Type": "application/json",
		Accept: "*/*"
	}
};

const jsonify = (p, errCallback) => {
	if (!errCallback) {
		errCallback = err => console.error("Bad API JSON Response:", err);
	}
	return p
		.then(response => {
			if (response.ok) {
				return response.json();
			}
			throw response;
		})
		.catch(errCallback);
};

const api = {
	baseUrl: "",
	setBaseUrl(newBaseUrl) {
		// console.log("Setting new API Base URL", newBaseUrl);
		this.baseUrl = newBaseUrl;
	},
	buildUrl(url) {
		return this.baseUrl + url;
	},
	buildOptions(options) {
		return Object.assign({}, defaultOptions, options);
	},
	fetch(url, options) {
		let retVal = window.fetch(this.buildUrl(url), this.buildOptions(options));
		return retVal;
	},
	buildQueryString(params) {
		return "?" + qs.stringify(params);
	},
	fetchJson(url, options, errCallback) {
		return jsonify(this.fetch(url, options), errCallback);
	},
	// TODO: cleanup HTTP actions (DRY)
	get(url, options) {
		return this.fetch(url, this.buildOptions(options));
	},
	getWithParams(url, params, options) {
		return this.fetch(
			url + this.buildQueryString(params),
			this.buildOptions(options)
		);
	},
	getJson(url, options, errCallback) {
		return jsonify(this.get(url, options), errCallback);
	},
	getWithParamsJson(url, params, options, errCallback) {
		return jsonify(this.getWithParams(url, params, options), errCallback);
	},
	post(url, body, options) {
		return this.fetch(
			url,
			Object.assign({}, defaultOptions, defaultPostOptions, options, {
				body: JSON.stringify(body)
			})
		);
	},
	postJson(url, body, options, errCallback) {
		return jsonify(
			this.fetch(
				url,
				Object.assign({}, defaultOptions, defaultPostOptions, options, {
					body: JSON.stringify(body)
				})
			),
			errCallback
		);
	},
	putJson(url, body, options, errCallback) {
		return jsonify(
			this.fetch(
				url,
				Object.assign({}, defaultOptions, defaultPutOptions, options, {
					body: JSON.stringify(body)
				})
			),
			errCallback
		);
	},
	patch(url, body, options) {
		return this.fetch(
			url,
			Object.assign({}, defaultOptions, defaultPatchOptions, options)
		);
	},
	patchJson(url, body, options, errCallback) {
		return jsonify(
			this.patch(
				url,
				body,
				Object.assign({}, options, {
					body: JSON.stringify(body)
				})
			),
			errCallback
		);
	},
	delete(url, body, options) {
		return this.fetch(
			url,
			Object.assign({}, defaultOptions, defaultDeleteOptions, options)
		);
	},
	deleteWithParams(url, params, options) {
		return this.delete(
			url + this.buildQueryString(params),
			this.buildOptions(options)
		);
	},
	deleteWithParamsJson(url, params, options, errCallback) {
		return jsonify(this.deleteWithParams(url, params, options), errCallback);
	},
	aspDateTimeConversion(dtString) {
		if (dtString === null) {
			return null;
		}
		if (typeof dtString !== "string") {
			if (typeof console.error === "function") {
				console.error(
					"Tried to convert bad backend date to date ISOString:",
					dtString
				);
			}
			return null;
		}
		// backend dates are formatted like so: '/Date(UNIX_TIMESTAMP)/'
		// chop off the first 6 characters, grab the timestamp, and you're set!
		return new Date(dtString);
	},
	ENDPOINTS: endpoints
};

export default api;
